/** @jsxImportSource @emotion/react */
"use client";

import { css } from "@emotion/react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";

import { numericPercentages, spacing } from "../../../../../global/emotion";

const rootStyle = css({
  display: "flex",
  flexDirection: "column",
  gap: spacing.s,
  width: numericPercentages[100],
});

export function Accordion({
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Root>) {
  return (
    <AccordionPrimitive.Root css={rootStyle} {...props}>
      {children}
    </AccordionPrimitive.Root>
  );
}
